import React, {  Component } from 'react';

export default class DuplicatePOOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialog && this.props.handleDialog("DuplicatePOOverlayDialog", false);
    }

    handleAction(action, event){
		event && event.preventDefault();
        this.setState({
            showDialog: false
        }, () => {
			this.props.handleAction(action);
		});
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="employeeAccount&PriceSourceDialog">
                <div className="blackoutLayer"></div>
                    <div className="overlayDialogWindow">
						<h2 className="title">Duplicate PO</h2>
                        <p>You have entered duplicate PO Number. Do you want to change it?</p>
                        <div className="noButtonContainer">
                            <a className="noButton blueButton" onClick={this.handleAction.bind(this, 'no')}>No</a>
                        </div>
                        <div className="yesButtonContainer">
                            <a className="yesButton blueButton" onClick={this.handleAction.bind(this, 'yes')}>Yes</a>
                        </div>
                    </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/duplicatePOOverlayDialog.js